import React, { useEffect } from 'react';
import { Container } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import '../Features.css';

const Frame = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.getElementById('home').classList.add('featureContent');
    return () => {
      document.getElementById('home').classList.remove('featureContent');
    };
  });
  useEffect(() => {
    setTimeout(() => {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }, 100);
  }, []);
  return (
    <Container className="featurePages speech">
      <div className="header">
        <div className="headerContent">
          <h2 className="title">{t('contents:frameTitle1')}</h2>
          <p className="text">{t('contents:frameParagraph1')}</p>
        </div>
        <img src={require('../../../assets/images/features/pages/frame/frame_01.png')} />
      </div>
      <div className="content">
        <div className="container">
          <div className="section section01">
            <div className="textBox">
              <h2 className="title">{t('contents:frameTitle2')}</h2>
              <p>{t('contents:frameParagraph2')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/frame/frame_02.png')} />
            </div>
          </div>
          <div className="section section02">
            <div className="textBox">
              <h2 className="title">{t('contents:frameTitle3')}</h2>
              <p>
                {t('contents:frameParagraph3')}
                <br />
                {t('contents:frameParagraph4')}
              </p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/frame/frame_03.png')} />
            </div>
          </div>
          <div className="section section03">
            <div className="textBox">
              <h2 className="title">{t('contents:frameTitle4')}</h2>
              <p>
                {t('contents:frameParagraph5')}
                <br />
                {t('contents:frameParagraph6')}
              </p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/frame/frame_04.png')} />
            </div>
          </div>
          <div className="section section04">
            <div className="textBox">
              <h2 className="title">{t('contents:frameTitle5')}</h2>
              <p>{t('contents:frameParagraph7')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/frame/frame_05.png')} />
            </div>
          </div>
          <div className="section section05">
            <div className="textBox">
              <h2 className="title">{t('contents:frameTitle6')}</h2>
              <p>{t('contents:frameParagraph8')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/frame/frame_06.png')} />
            </div>
          </div>
          {/* <div className="section section06">
            <div className="textBox">
              <h2 className="title">{t('contents:frameTitle6')}</h2>
              <p>{t('contents:frameParagraph9')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/frame/frame_07.png')} />
            </div>
          </div> */}
        </div>
        <div className="footer"></div>
      </div>
    </Container>
  );
};

export default Frame;
